import formsSlice from './slice'

export const { updateState, saveValues, replaceValues, resetValues } =
  formsSlice.actions
